import { render, staticRenderFns } from "./network.vue?vue&type=template&id=2f1e7bf4&scoped=true"
import script from "./network.vue?vue&type=script&lang=js"
export * from "./network.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1e7bf4",
  null
  
)

export default component.exports